BatchGeoStore.addReducer("MobileInfoWindow", function (state, action) {
  state = state || {
    initialized: false,
    open: false,
    marker: null,
    showDetails: false,
    $dom: $(null),
    $closeButton: $(null),
    $menuToggle: $(null),
    $address: $(null),
    $toolbar: $(null),
    container: null,
    dataViewWasOpen: false,
  };

  switch (action.type) {
    case "MOBILE_INFOWINDOW_INIT":
      return _.merge({}, state, {
        initialized: true,
        container: action.container,
      });

    case "MOBILE_INFOWINDOW_OPEN":
      return _.merge({}, state, {
        open: true,
        marker: action.marker,
        dataViewWasOpen: action.dataViewWasOpen,
      });

    case "MOBILE_INFOWINDOW_CLOSE":
      return _.merge({}, state, {
        open: false,
        marker: null,
      });

    case "MOBILE_INFOWINDOW_DETAILS_CLOSE":
      return _.merge({}, state, { showDetails: false });

    case "MOBILE_INFOWINDOW_DETAILS_TOGGLE":
      return _.merge({}, state, { showDetails: !state.showDetails });

    case "MOBILE_INFOWINDOW_SAVE_DOM":
      return _.merge({}, state, {
        $dom: action.$dom,
        $closeButton: action.$closeButton,
        $address: action.$address,
        $menuToggle: action.$menuToggle,
        $toolbar: action.$toolbar,
      });

    default:
      return state;
  }
});
